module.exports = __webpack_public_path__ + "img/Origine_France2.be5eeedc.png";